import { IOrderElement } from './../model/types'

export const calcSumAlienSelectedElements = (array: IOrderElement[], guestID: number): number => {
  if (array.length) {
    return array.reduce((sum: number, element: IOrderElement): number => {
      const selectedElement: number =
        element.selected_guest_id && element.selected_guest_id !== guestID
          ? element.finalPrice
          : 0
      return sum + selectedElement / 100
    }, 0)
  }
  return 0
}

export const getSelectedID = (orderElements: IOrderElement[], diffCheck: boolean): number[] => {
  const selectedEl: boolean = orderElements.some((i: IOrderElement) => i.selected)
  if (
    diffCheck ||
    (!diffCheck && selectedEl)
  ) {
    return orderElements.filter((i: IOrderElement) => i.selected).map(
      i => i.id
    )
  } else {
    return orderElements.filter(
      (i: IOrderElement) => !i.selected_guest_id && i.status === 'NOT_PAID'
    ).map(i => i.id)
  }
}

export const getStatusPayed = (OrderElements: IOrderElement[], payingElementsID: number[]): boolean => {
  const AllElementsId: number[] = OrderElements
    .filter((i: IOrderElement): boolean => i.status === 'NOT_PAID')
    .map((i: IOrderElement): number => i.id)
  return (
    AllElementsId.length === payingElementsID.length &&
    AllElementsId.every((v: number, i: number): boolean => v === payingElementsID[i])
  )
}
